import { Mail, Instagram, Twitter } from "lucide-react";

export default function Footer() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0a0a0a] border-t border-[#1a1a1a] pt-20 px-6 md:px-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        {/* Top */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-block w-2 h-2 rounded-full bg-[#eab308] bham-dot" />
              <span className="font-display text-2xl tracking-tight">
                BHAM<span className="text-[#eab308]">.</span>BASEBALL
              </span>
            </div>
            <p className="text-neutral-400 max-w-sm">
              Elite pitching development for serious high school and college
              athletes. Remote, in-person, and hybrid programs.
            </p>
            <button
              data-testid="footer-apply-btn"
              onClick={() => scrollTo("apply")}
              className="mt-6 inline-flex items-center gap-2 bg-[#eab308] hover:bg-[#facc15] text-black font-bold uppercase font-condensed tracking-widest px-5 py-2.5 rounded-sm transition-all"
            >
              Apply Now
            </button>
          </div>

          <div className="md:col-span-3">
            <div className="font-condensed uppercase tracking-[0.25em] text-xs text-neutral-500 mb-4">
              Explore
            </div>
            <ul className="space-y-3">
              {[
                ["services", "Services"],
                ["results", "Results"],
                ["apply", "Application"],
                ["about", "About"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollTo(id)}
                    className="font-condensed uppercase tracking-wider text-neutral-300 hover:text-[#eab308]"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-condensed uppercase tracking-[0.25em] text-xs text-neutral-500 mb-4">
              Connect
            </div>
            <div className="flex gap-3">
              <SocialBtn icon={Instagram} label="Instagram" />
              <SocialBtn icon={Twitter} label="Twitter" />
              <SocialBtn icon={Mail} label="Email" />
            </div>
            <p className="text-xs text-neutral-500 mt-6 max-w-xs">
              Edmond, OK based — coaching athletes nationwide remotely & in
              person.
            </p>
          </div>
        </div>

        {/* Oversized brand text */}
        <div className="border-t border-[#1a1a1a] pt-8 pb-6">
          <div className="font-display text-[18vw] md:text-[15vw] leading-none text-center text-white/[0.07] tracking-tighter select-none">
            BHAM<span className="text-[#eab308]/20">.</span>BASEBALL
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 py-6 border-t border-[#1a1a1a] text-xs text-neutral-500 font-condensed uppercase tracking-[0.2em]">
          <div>© {new Date().getFullYear()} Bham Baseball</div>
          <div className="flex items-center gap-6">
            <span>Making A Game Your Future.</span>
            <a
              href="/admin"
              data-testid="footer-coach-login"
              className="hover:text-[#eab308] transition-colors"
            >
              Coach Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialBtn({ icon: Icon, label }) {
  return (
    <button
      data-testid={`social-${label.toLowerCase()}`}
      aria-label={label}
      className="w-11 h-11 border border-[#2a2a2a] hover:border-[#eab308] hover:text-[#eab308] flex items-center justify-center transition-all"
    >
      <Icon size={18} />
    </button>
  );
}
